import {css} from 'aphrodite';
import React, {Dispatch, SetStateAction} from 'react';

import {ResidueType} from 'biojs/BioConstants';
import BLASTOperatorToggleGroup from 'search/blast/BLASTOperatorToggleGroup';
import {BLASTInputSource} from 'search/blast/BLASTTracking';
import {hasNucleotideInput} from 'search/blast/BLASTUtil';
import {styles} from 'search/blast/constants';
import {BLASTFilter, BLASTOperator, Operator} from 'search/SearchConstants';
import Label from 'ui-library/bs/Label';

export interface SelectBlastTypePaneProps {
  filter: BLASTFilter;
  setFilter: Dispatch<SetStateAction<BLASTFilter>>;
  setInputSources?: Dispatch<SetStateAction<Record<string, BLASTInputSource>>>;
  // if included, will restrict which BLAST types to choose from
  residueType?: ResidueType;
}

export default function SelectBlastTypePane({
  filter,
  setFilter,
  setInputSources,
  residueType,
}: SelectBlastTypePaneProps): JSX.Element {
  const onChangeType = (type: Operator): void => {
    // doesn't allow user to change to type with the wrong input
    if (residueType === ResidueType.NUCLEOTIDE && !hasNucleotideInput(type as BLASTOperator)) {
      return;
    } else if (residueType === ResidueType.AA && hasNucleotideInput(type as BLASTOperator)) {
      return;
    }

    setFilter((previousFilter) => ({
      ...previousFilter,
      operator: type,
      // When changing BLAST algorithms, the selected entities and text sequences
      // will be of the wrong entity type, so clear them.
      value: {
        textSequences: [],
        apiIdentifiers: [],
      },
      // Params are different for each BLAST algorithm, so clear them when changing operator.
      params: {},
    }));
    if (setInputSources) {
      setInputSources({});
    }
  };

  return (
    <>
      <Label className={css(styles.headerLabel)}>BLAST type</Label>
      <BLASTOperatorToggleGroup operator={filter.operator} onChangeType={onChangeType} />
    </>
  );
}
